export const JUMPTRACK_THEME = 'jumptrack';
export const KARMAK_THEME = 'karmak';
export const CPI_THEME = 'cpi';
export const MIN_RESIZE_HEIGHT = 50;
